import { Injectable } from '@angular/core';
import { Router }     from '@angular/router';

import { filter, take } from 'rxjs/operators';

import { AuthUser }    from '@models/user/auth-user';
import { UserService } from '@services/user.service';


export type CheckRouteFn = (user: AuthUser, router: Router) => void;

@Injectable({ providedIn: 'root' })
export class HubsService {

  constructor(
    private router:      Router,
    private userService: UserService
  ) { }

  private static getManagerRoute(_user: AuthUser): string {
    return '/dash/coordenador';
  }

  private static readonly HOME_ROUTES = new Map<string, string | ( (user: AuthUser) => string )>([
    [ 'SUPER_ADMIN', '/dash/admin' ],
    [ 'ADMIN', '/dash/admin' ],
    [ 'PROFESSOR', '/correcao' ],
    [ 'CORRETOR_SAAS', '/correcao' ],
    [ 'COORDENADOR_ESCOLA', HubsService.getManagerRoute ],
    [ 'COORDENADOR_TURMA', HubsService.getManagerRoute ],
    [ 'COORDENADOR_SAAS', HubsService.getManagerRoute ],
    [ 'ALUNO', '/redacao/lista' ],
    [ 'ALUNO_B2C', '/redacao/lista' ],
    [ 'ASSESSOR', '/dash/assessor' ]
  ]);

  public static computeHomeRoute(user: AuthUser): string {
    const route = HubsService.HOME_ROUTES.get(user.perfil);
    return typeof route === 'function' ? route(user) : route;
  }

  public static isHomeRoute(user: AuthUser, url: string): boolean {
    if (!user || !url) return false;

    const home = HubsService.normalizePath(HubsService.computeHomeRoute(user));
    if (!home) return false;

    const current = HubsService.normalizePath(url);
    return current === home;
  }

  private static normalizePath(url: string): string {
    if (!url) return '';

    const [ path ] = url.split(/[?#]/);
    if (!path) return '';
    if (path === '/') return path;

    return path.endsWith('/') ? path.slice(0, -1) : path;
  }

  public getHomeRoute(user: AuthUser): string {
    return HubsService.computeHomeRoute(user);
  }

  public checkUserType(checkRouteFn: CheckRouteFn) {

    if (this.userService.isLoggedIn() || this.userService.hasValidPidAuthParams()) {
      this.userService.initUser().pipe(
        filter((user: AuthUser) => !!user),
        take(1)
      ).subscribe((user: AuthUser) => checkRouteFn(user, this.router));

      return;
    }

    this.router.navigate([ '/home' ]).then();
  }

}
